import React from 'react';
import { Target, Zap, Users, Globe } from 'lucide-react';

const About = () => {
  const features = [
    {
      icon: Zap,
      title: 'Technology-Driven',
      description: 'Advanced AI and automation at the core of every solution'
    },
    {
      icon: Target,
      title: 'Results-Focused',
      description: 'Measurable growth through data-driven strategies'
    },
    {
      icon: Users,
      title: 'Multidisciplinary Team',
      description: 'Experts in design, technology, and strategic intelligence'
    },
    {
      icon: Globe,
      title: 'Global Reach',
      description: 'Supporting international expansion and market entry'
    }
  ];

  return (
    <section id="about" className="about-section">
      <div className="about-container">
        <div className="about-header">
          <span className="section-label">About Us</span>
          <h2 className="section-title">Integrated Digital, AI, and Business Solutions</h2>
          <p className="section-description">
            At MILAMIA, we deliver integrated digital, AI, and business solutions designed
            to help brands build strong foundations and scale globally.
          </p>
        </div>

        <div className="about-content">
          <div className="about-text">
            <div className="about-mission">
              <h3 className="mission-title">Our Approach</h3>
              <p className="mission-text">
                Our multidisciplinary team combines technology, design, and strategic intelligence
                to transform ideas into measurable growth. We don't just deliver projects—we
                engineer complete ecosystems that enable our clients to operate efficiently, scale
                confidently, and stand out globally.
              </p>
            </div>

            <div className="about-commitment">
              <h3 className="commitment-title">What Sets Us Apart</h3>
              <p className="commitment-text">
                We unite creativity with advanced technology, focusing on scalability, performance,
                and conversion at every touchpoint. From AI-powered automation to global business
                setup, we provide end-to-end solutions that drive real results.
              </p>
            </div>
          </div>

          <div className="about-features">
            {features.map((feature, index) => {
              const IconComponent = feature.icon;
              return (
                <div key={index} className="feature-card">
                  <div className="feature-icon-wrapper">
                    <IconComponent className="feature-icon" size={24} />
                  </div>
                  <div className="feature-content">
                    <h4 className="feature-title">{feature.title}</h4>
                    <p className="feature-description">{feature.description}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;